import { X } from "lucide-react";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.scss";
import "slick-carousel/slick/slick.css";
import api from "../../api/client";
import classes from "./Carousel.module.scss";


const Carousel = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);


  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    let alive = true;

    async function loadBanners() {
      try {
        // IMPORTANT: your backend endpoint is /api/config/banners/
        const res = await api.get("/api/config/banners/");
        if (alive) setBanners(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to load banners", err);
        if (alive) setBanners([]);
      } finally {
        if (alive) setLoading(false);
      }
    }

    loadBanners();
    return () => {
      alive = false;
    };
  }, []);



  const settings = {
    dots: true,
    infinite: banners.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    centerPadding: "10%",
        // auto scroll
    autoplay: banners.length > 1 && !selectedEvent,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipeToSlide: true,
    customPaging: (i) => (
      <div className={classes.customDot}></div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "60px",
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "40px",
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: "20px",
        }
      }
    ]
  };

  

  if (loading || banners.length === 0) return null;
  return (
    <div className={classes.parallaxSlider}>
      <Slider {...settings}>
        {banners.map((banner) => (
          <div key={banner.id} className={classes.slideWrapper}>
            <div
              className={classes.slideImage}
              onClick={() => setSelectedEvent(banner)}
              style={{
                backgroundImage: `url(${banner.image_url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                cursor: "pointer"
              }}
            ></div>
          </div>
        ))}
      </Slider>

      {selectedEvent && (
        <div className={classes.modalOverlay} onClick={() => setSelectedEvent(null)}>
          <div className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
            <img src={selectedEvent.image_url} alt={selectedEvent.title} className={classes.modalImage} />
            <div className={classes.modalText}>
              <h2>{selectedEvent.title}</h2>
              <p style={{ whiteSpace: "pre-line", textAlign: "left" }}>{selectedEvent.description}</p>
              {selectedEvent.link && (
                <a href={selectedEvent.link} target="_blank" rel="noopener noreferrer"
                className={classes.modalLink}>
                  {selectedEvent.link_text || "Open link"}
                </a>
              )}

            </div>
            <button className={classes.closeButton} onClick={() => setSelectedEvent(null)}>
              <X size={24} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Carousel;
